import { PDFViewer } from '@react-pdf/renderer'
import React, { useEffect, useMemo, useState, useDeferredValue } from 'react'
import SplitPane from 'react-split-pane';
import EnhancedControlPanel from './components/EnhancedControlPanel';
import PDFDocument from './components/PDFDocument';
import { defaultDocumentData } from '../../data/defaultPdf';
import './CreatePdf.scss';

export default function CreatePdf() {
    // 文档数据状态
    const [documentData, setDocumentData] = useState(defaultDocumentData);
    // 水印配置状态
    const [watermarkConfig, setWatermarkConfig] = useState({
      enabled: false,
      text: '外刊来了',
      opacity: 0.3,
      rotation: -45,
      fontSize: 12,
      color: '#cccccc',
      density: 'medium',
      layer: 'front' // 'front' 最前层, 'back' 最后层
    });
    // 分割线宽度受控
    const [splitSize, setSplitSize] = useState(window.innerWidth - 400);
    // 添加一个强制更新的key，确保PDF组件重新渲染
    const [pdfKey, setPdfKey] = useState(0);
  const [wordIndexMargins, setWordIndexMargins] = useState({});

    // 使用 deferred 数据，降低 PDF 重渲染频率
    const deferredDocumentData = useDeferredValue(documentData);

    // 强制更新PDF的函数（尽量少用）
    const forceUpdatePDF = () => {
      setPdfKey(prev => prev + 1);
    };

    // 确保组件初始化时触发PDF渲染
    useEffect(() => {
      forceUpdatePDF();
    }, []);

    // 处理文档数据变化
    const handleDocumentDataChange = (newData) => {
      setDocumentData(newData);
      // 移除每次都强制重渲染，交给 deferredValue 节流
      // forceUpdatePDF();
    };

    // 使用useMemo确保PDF文档在props变化时重新创建
    const pdfDocument = useMemo(() => {
      return (
        <PDFDocument
          // key={`pdf-${pdfKey}`} // 不再强制重挂载
          documentData={deferredDocumentData}
          watermarkConfig={watermarkConfig}
          wordIndexMargins={wordIndexMargins}
        />
      );
    }, [deferredDocumentData, watermarkConfig, wordIndexMargins]);

    return (
      <div style={{height: '100vh'}}>
        <SplitPane
          split="vertical"
          minSize={280}
          maxSize={-280}
          size={splitSize}
          onChange={size => setSplitSize(size)}
          paneStyle={{display: 'flex'}}
          pane1Style={{display: 'flex'}}
          pane2Style={{display: 'flex'}}
          allowResize={false}
        >
          {/* 左侧PDF预览区域 */}
          <div className="pdf-preview-wrapper">
            <div className="pdf-viewer-container">
              <PDFViewer
                // key={`iframe-${pdfKey}`}
                className="pdf-viewer"
                showToolbar={true}
              >
                {pdfDocument}
              </PDFViewer>
            </div>
          </div>
          {/* 右侧控制面板 */}
          <div className="control-panel-sider">
            <EnhancedControlPanel
              documentData={documentData}
              onDocumentDataChange={handleDocumentDataChange}
              watermarkConfig={watermarkConfig}
              setWatermarkConfig={setWatermarkConfig}
              wordIndexMargins={wordIndexMargins}
              setWordIndexMargins={setWordIndexMargins}
            />
          </div>
        </SplitPane>
      </div>
    )
}
